<template>
  <div v-if="computedQwTag && computedQwTag.length > 0">
    <div class="title">
      <el-tag size="small" class="title-tag">企微标签：
      </el-tag>
    </div>
    <el-tag class="tag" size="small" type="warning" effect="plain" v-for="({key, val}, index) in computedQwTag" :key="index">{{ `${key}：${val}` }}</el-tag>
  </div>
</template>

<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
    }
  },
  computed: {
    computedQwTag() {
      let value = []
      for(const ele of this.tags) {
        const val = Object.values(ele)[0]
        const key = Object.keys(ele)[0]
        if(val !== "" && val !== '0') {
          value.push({key, val})
        }
      }
      return value
    }
  }
}
</script>

<style scoped>
.title {
  margin-top: 10px;
  margin-bottom: 8px;
}

.title-tag {
  background-color: white;
}

.def-item {
  display: flex;
}

.def-item-title {
  width: 100px;
}

.def-item-content {
  flex: 1
}

.tag {
  margin-right: 3px;
  margin-bottom: 3px;
  color: #606266;
}
</style>